import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormWhatsAppNumber from "./FormWhatsAppNumber";
import ModalBox from "../../ui/ModalBox";

const AddWhatsAppNumber = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New WhatsApp Number
      </Typography>
      <FormWhatsAppNumber handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new WhatsApp Number"
        name="WhatsApp Number"
      />
    </>
  );
};

export default AddWhatsAppNumber;
